import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const CloudHeroSlide = ({
  title = "Cloud First",
  subtitle = "Embrace cloud-native solutions for scalable, secure, and cost-effective digital transformation",
  primaryLink = { text: "Get Started", to: "/contact" },
  secondaryLink = { text: "Learn More", to: "/services" },
}) => {
  const scrollIntoView = () => {
    const element = document.getElementById("learn-more-cloud");
    if (element) {
      const yOffset = -80; // adjust based on your header height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 lg:py-56 z-40">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center"
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          {title}
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl mb-8 text-indigo-100 font-medium">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={primaryLink.to}
            className="px-8 py-3 bg-white text-indigo-600 rounded-md hover:bg-gray-100 transition-colors font-medium"
          >
            {primaryLink.text}
          </Link>
          <Link
            // to={secondaryLink.to}
            to="#"
            onClick={scrollIntoView}
            className="px-8 py-3 border border-white text-white rounded-md hover:bg-white hover:text-indigo-600 transition-colors font-medium"
          >
            {secondaryLink.text}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default CloudHeroSlide;
